<form [formGroup]="form">
  <div class="form-grid">
    <div *ngFor="let field of fields">
      <label [attr.for]="field.label" class="input-label" *ngIf="field.label">
        {{ field.label }}
        <span *ngIf="field.required" class="required-star">*</span>
      </label>

      <ng-container [ngSwitch]="field.type">

        <!-- Text input -->
        <mat-form-field *ngSwitchCase="'text'" appearance="outline">
          <input matInput [formControlName]="field.name" placeholder="Nhập {{ field.label }}" />
        </mat-form-field>

        <!-- Multi-line text -->
        <mat-form-field *ngSwitchCase="'textarea'" appearance="outline" style=" margin-bottom: 15px;">
          <textarea matInput [formControlName]="field.name" placeholder="Nhập {{ field.label }}"></textarea>
        </mat-form-field>

        <!-- Radio buttons -->
        <!-- <div *ngSwitchCase="'radio'">
          <mat-radio-group [formControlName]="field.name">
            <div class="radio-grid">
              <div *ngFor="let option of field.options" class="radio-item">
                <mat-radio-button [value]="option.key">{{ option.value }}</mat-radio-button>
              </div>
            </div>
          </mat-radio-group>
        </div> -->
        <div *ngSwitchCase="'radio'">
          <mat-radio-group [formControlName]="field.name">
            <div class="radio-grid">
              <div *ngFor="let option of field.options" class="radio-item">
                <mat-radio-button [value]="option.key">{{ option.value }}</mat-radio-button>
              </div>
            </div>
          </mat-radio-group>
        </div>


        <!-- Checkboxes -->
        <div *ngSwitchCase="'checkbox'">
          <div class="checkbox-grid">
            <div *ngFor="let option of field.options" class="checkbox-item">
              <label>
                <input type="checkbox" [value]="option.key" (change)="onCheckboxChange($event, field.name)"
                  [checked]="isCheckboxChecked(option.key, field.name)" />
                <span>{{ option.value }}</span>
              </label>
            </div>
          </div>
        </div>
        <!-- Single select dropdown -->
        <mat-form-field *ngSwitchCase="'select'" appearance="outline">
          <mat-select [formControlName]="field.name" placeholder="Chọn {{ field.label }}">
            <mat-option *ngFor="let option of field.options" [value]="option.key">
              {{ option.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Multiple select dropdown -->
        <mat-form-field *ngSwitchCase="'multiselect'" appearance="outline">
          <mat-select [formControlName]="field.name" multiple placeholder="Chọn {{ field.label }}">
            <mat-option *ngFor="let option of field.options" [value]="option.key">
              {{ option.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Date picker -->
        <mat-form-field *ngSwitchCase="'date'" appearance="outline">
          <input matInput [matDatepicker]="picker" [formControlName]="field.name"
            placeholder="Nhập {{ field.label }}" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <!-- File input -->
        <div  *ngSwitchCase="'file'" class="file-upload-container">
          <label for="fileInput" class="file-upload-label">
            <mat-icon>upload</mat-icon>
            <span>Chọn tệp {{field.label }} </span>
          </label>
          <input 
            type="file" 
            id="fileInput" 
            (change)="onFileChange($event)" 
            class="file-upload-input" 
          />
          <div *ngIf="selectedFileName" class="file-info">
            <mat-icon>insert_drive_file</mat-icon>
            <span>{{ selectedFileName }}</span>
          </div>
        </div>
        

        <!-- Default message for unsupported types -->
        <p *ngSwitchDefault>Unsupported field type: {{ field.type }}</p>
      </ng-container>

      <div *ngIf="form.get(field.name)?.invalid && form.get(field.name)?.touched">
        {{ field.label }} is required.
      </div>
    </div>
  </div>
</form>